<div class="fixed inset-0 flex items-center justify-center backdrop-blur-md bg-white/10">
    <!-- Contenedor del loader -->
    <div class="relative flex flex-col items-center">
      
      <!-- Línea giratoria con gradiente sutil -->
      <div class="relative w-40 h-40">
        <!-- Anillo exterior giratorio -->
        <div class="absolute inset-0 rounded-full border-[6px] border-transparent border-t-[#003aa2] border-r-[#003aa2]/80 animate-spin"
             style="animation-duration: 2s"></div>
        
        <!-- Anillo interior giratorio (sentido contrario) -->
        <div class="absolute inset-3 rounded-full border-[4px] border-transparent border-b-[#003aa2]/60 border-l-[#003aa2] animate-spin"
             style="animation-duration: 3s; animation-direction: reverse"></div>
        
        <!-- Imagen central con sombra y borde sutil -->
        <div class="absolute inset-0 flex items-center justify-center">
          <img src="img/logo-finco.png" alt="Logo" 
               class="w-20 h-20 object-contain p-2 rounded-full bg-white/90 shadow-lg border border-gray-200/50">
        </div>
      </div>
      
      <!-- Texto con efecto de aparición -->
      <p class="mt-6 text-lg font-medium text-[#003aa2] animate-pulse px-24 text-center">
        {{ textInfo }}
      </p>
    </div>
  </div>